import { ListAttributeSchemaNames } from '@app/data/manageLists/listAttributes';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { LocalStorage } from '@vectord/utils';

const lsInstance = LocalStorage.getInstance('store.lists.secondaryFilter');

const initialState = {
  searchText: '',
  createdByFilter: 'any',
  sortConfig: {
    sortField: ListAttributeSchemaNames.createdBy,
    sortOrder: 'desc',
  },
};

const savedConfig = lsInstance?.config;

export const secondaryFilterSlice = createSlice({
  name: 'manageLists/SecondaryFilter',
  initialState: { ...initialState, ...savedConfig },
  reducers: {
    addSecondaryFilter: (state, action: PayloadAction<{
      searchText?: string;
      createdByFilter?: string;
    }>) => ({
      ...state,
      ...action.payload,
    }),
    setSortConfig: (state, action: PayloadAction<{
      sortField?: string,
      sortDirection?: 'ascend' | 'descend',
    }>) => {
      let sortOrder: 'asc' | 'desc' = 'desc';
      if (action.payload.sortDirection === 'ascend') {
        sortOrder = 'asc';
      } else if (action.payload.sortDirection === 'descend') {
        sortOrder = 'desc';
      }
      state.sortConfig = {
        sortField: action.payload.sortField || ListAttributeSchemaNames.createdBy,
        sortOrder,
      };
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('manageLists/SecondaryFilter/'),
      (state) => { lsInstance.config = state; },
    );
  },
});

export const {
  addSecondaryFilter,
  setSortConfig,
  setSearchText,
} = secondaryFilterSlice.actions;

export default secondaryFilterSlice.reducer;
